var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "div",
      { staticClass: "w-full flex flex-col md:flex-row mt-4 lg:mt-8" },
      [
        _c(
          "div",
          { staticClass: "w-full lg:w-1/2" },
          [
            _c("div", { staticClass: "flex flex-col items-center mb-6" }, [
              _c("div", { staticClass: "w-6/12 px-4 mb-6" }, [
                _c("img", {
                  staticClass:
                    "shadow rounded-full max-w-full h-auto align-middle border-none",
                  attrs: {
                    alt: "...",
                    src: _vm.profilePicture
                      ? _vm.profilePicture
                      : _vm.imgPlaceholder
                  }
                })
              ]),
              _vm._v(" "),
              _vm._m(0),
              _vm._v(" "),
              _vm.labelErrorImageMessage !== ""
                ? _c(
                    "div",
                    { staticClass: "flex flex-col mb-2" },
                    [
                      _vm.labelErrorImageMessage !== ""
                        ? _c("text-error", {
                            attrs: { text: _vm.labelErrorImageMessage }
                          })
                        : _vm._e()
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "flex" },
                [
                  !_vm.profilePicture
                    ? _c("Button", {
                        attrs: { label: "Browse File" },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "any",
                              fn: function() {
                                return [
                                  _c("input", {
                                    staticStyle: {
                                      width: "100%",
                                      height: "100%",
                                      position: "absolute",
                                      left: "0",
                                      top: "0",
                                      opacity: "0",
                                      cursor: "pointer",
                                      "z-index": "2"
                                    },
                                    attrs: {
                                      type: "file",
                                      name: "profile_picture",
                                      accept: "image/*"
                                    },
                                    on: { change: _vm.onFileChange }
                                  })
                                ]
                              },
                              proxy: true
                            }
                          ],
                          null,
                          false,
                          1048279932
                        )
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.profilePicture
                    ? _c("Button", {
                        attrs: { label: "Remove", variant: "default" },
                        on: { clicked: _vm.changeImage }
                      })
                    : _vm._e()
                ],
                1
              )
            ]),
            _vm._v(" "),
            _c("ImageCropModal", {
              attrs: {
                show: _vm.showCropModal,
                "image-src": _vm.pendingImageSrc,
                title: "Crop Profile Picture"
              },
              on: { cropped: _vm.onCropCropped, cancel: _vm.onCropCancel }
            }),
            _vm._v(" "),
            _c("form-item", {
              attrs: { label: "First Name" },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function() {
                    return [
                      _c("Input", {
                        attrs: {
                          placeholder: "First Name",
                          error:
                            _vm.$v.first_name.$dirty &&
                            (!_vm.$v.first_name.required ||
                              !_vm.$v.first_name.maxLength)
                        },
                        model: {
                          value: _vm.first_name,
                          callback: function($$v) {
                            _vm.first_name = $$v
                          },
                          expression: "first_name"
                        }
                      }),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "flex flex-col pt-2" },
                        [
                          _vm.$v.first_name.$dirty &&
                          !_vm.$v.first_name.required
                            ? _c("text-error", {
                                attrs: { text: "Please fill your first name." }
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.$v.first_name.$dirty &&
                          !_vm.$v.first_name.maxLength
                            ? _c("text-error", {
                                attrs: {
                                  text:
                                    "Maximum character for name is 100 characters."
                                }
                              })
                            : _vm._e()
                        ],
                        1
                      )
                    ]
                  },
                  proxy: true
                }
              ])
            }),
            _vm._v(" "),
            _c("form-item", {
              attrs: { label: "Last Name" },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function() {
                    return [
                      _c("Input", {
                        attrs: {
                          placeholder: "Last Name",
                          error:
                            _vm.$v.last_name.$dirty &&
                            (!_vm.$v.last_name.required ||
                              !_vm.$v.last_name.maxLength)
                        },
                        model: {
                          value: _vm.last_name,
                          callback: function($$v) {
                            _vm.last_name = $$v
                          },
                          expression: "last_name"
                        }
                      }),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "flex flex-col pt-2" },
                        [
                          _vm.$v.last_name.$dirty && !_vm.$v.last_name.required
                            ? _c("text-error", {
                                attrs: { text: "Please fill your last name." }
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.$v.last_name.$dirty && !_vm.$v.last_name.maxLength
                            ? _c("text-error", {
                                attrs: {
                                  text:
                                    "Maximum character for name is 100 characters."
                                }
                              })
                            : _vm._e()
                        ],
                        1
                      )
                    ]
                  },
                  proxy: true
                }
              ])
            }),
            _vm._v(" "),
            _c("form-item", {
              attrs: { label: "Email" },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function() {
                    return [
                      _c("Input", {
                        attrs: {
                          placeholder: "Email",
                          error:
                            _vm.$v.email.$dirty &&
                            (!_vm.$v.email.required ||
                              !_vm.$v.email.email ||
                              _vm.errIsEmailExist)
                        },
                        model: {
                          value: _vm.email,
                          callback: function($$v) {
                            _vm.email = $$v
                          },
                          expression: "email"
                        }
                      }),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "flex flex-col pt-2" },
                        [
                          _vm.$v.email.$dirty && !_vm.$v.email.required
                            ? _c("text-error", {
                                attrs: { text: "Please fill your email." }
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.$v.email.$dirty && !_vm.$v.email.email
                            ? _c("text-error", {
                                attrs: {
                                  text: "Please fill your correct email."
                                }
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.$v.email.$dirty && _vm.errIsEmailExist
                            ? _c("text-error", {
                                attrs: { text: "Email is already in use." }
                              })
                            : _vm._e()
                        ],
                        1
                      )
                    ]
                  },
                  proxy: true
                }
              ])
            }),
            _vm._v(" "),
            _c("form-item", {
              attrs: { label: "Language" },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function() {
                    return [
                      _c(
                        "el-select",
                        {
                          staticClass: "w-full",
                          class:
                            _vm.$v.language.$dirty && _vm.$v.language.$anyError
                              ? "border-red-500"
                              : "",
                          attrs: {
                            filterable: "",
                            placeholder: "Select Language"
                          },
                          model: {
                            value: _vm.language,
                            callback: function($$v) {
                              _vm.language = $$v
                            },
                            expression: "language"
                          }
                        },
                        _vm._l(_vm.dataLanguages, function(item) {
                          return _c("el-option", {
                            key: item.value,
                            attrs: { label: item.label, value: item.value }
                          })
                        }),
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "flex flex-col pt-2" },
                        [
                          _vm.$v.language.$dirty && !_vm.$v.language.required
                            ? _c("text-error", {
                                attrs: { text: "Please fill your language." }
                              })
                            : _vm._e()
                        ],
                        1
                      )
                    ]
                  },
                  proxy: true
                }
              ])
            })
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "w-full lg:w-1/2" },
          [
            _c("form-item", {
              attrs: { label: "Date of Birth" },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function() {
                    return [
                      _c("Input", {
                        attrs: {
                          type: "date",
                          placeholder: "Date of Birth",
                          error: _vm.$v.dob.$dirty && !_vm.$v.dob.required
                        },
                        model: {
                          value: _vm.dob,
                          callback: function($$v) {
                            _vm.dob = $$v
                          },
                          expression: "dob"
                        }
                      }),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "flex flex-col pt-2" },
                        [
                          _vm.$v.dob.$dirty && !_vm.$v.dob.required
                            ? _c("text-error", {
                                attrs: { text: "Please fill your Birthdate." }
                              })
                            : _vm._e()
                        ],
                        1
                      )
                    ]
                  },
                  proxy: true
                }
              ])
            }),
            _vm._v(" "),
            _c("form-item", {
              attrs: { label: "Bio" },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function() {
                    return [
                      _c(
                        "div",
                        { staticClass: "relative" },
                        [
                          _c("TextArea", {
                            attrs: {
                              placeholder: "Tell us about you",
                              error: _vm.$v.bio.$dirty && !_vm.$v.bio.required,
                              rows: "3",
                              "max-length": _vm.maxLengthBio
                            },
                            model: {
                              value: _vm.bio,
                              callback: function($$v) {
                                _vm.bio = $$v
                              },
                              expression: "bio"
                            }
                          }),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "absolute right-0 text-xs",
                              staticStyle: { bottom: "15px", right: "15px" }
                            },
                            [
                              _vm._v(
                                _vm._s(_vm.bio.length) +
                                  "/" +
                                  _vm._s(_vm.maxLengthBio)
                              )
                            ]
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "flex flex-col pt-2" },
                        [
                          _vm.$v.bio.$dirty && !_vm.$v.bio.required
                            ? _c("text-error", {
                                attrs: { text: "Please fill your Bio." }
                              })
                            : _vm._e()
                        ],
                        1
                      )
                    ]
                  },
                  proxy: true
                }
              ])
            }),
            _vm._v(" "),
            _c("form-item", {
              attrs: { label: "Password" },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function() {
                    return [
                      _c(
                        "div",
                        { staticClass: "relative" },
                        [
                          _c("Input", {
                            attrs: {
                              type: _vm.showPassword ? "text" : "password",
                              placeholder: "Password",
                              error:
                                _vm.$v.password.$dirty &&
                                !_vm.$v.password.required
                            },
                            model: {
                              value: _vm.password,
                              callback: function($$v) {
                                _vm.password = $$v
                              },
                              expression: "password"
                            }
                          }),
                          _vm._v(" "),
                          _c(
                            "a",
                            {
                              staticClass: "absolute top-0 right-0 mr-2 mt-3 ",
                              staticStyle: { cursor: "pointer" },
                              on: {
                                click: function($event) {
                                  _vm.showPassword = !_vm.showPassword
                                }
                              }
                            },
                            [
                              _c("i", {
                                staticClass: "fa",
                                class: _vm.showPassword
                                  ? "fa-eye-slash"
                                  : "fa-eye"
                              })
                            ]
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "flex flex-col pt-2" },
                        [
                          _vm.$v.password.$dirty && !_vm.$v.password.required
                            ? _c("text-error", {
                                attrs: { text: "Please fill the password." }
                              })
                            : _vm._e()
                        ],
                        1
                      )
                    ]
                  },
                  proxy: true
                }
              ])
            }),
            _vm._v(" "),
            _c("form-item", {
              attrs: { label: "Confirm Password" },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function() {
                    return [
                      _c(
                        "div",
                        { staticClass: "relative" },
                        [
                          _c("Input", {
                            attrs: {
                              type: _vm.showConfirmPassword
                                ? "text"
                                : "password",
                              placeholder: "Confirm Password",
                              error:
                                _vm.$v.repassword.$dirty &&
                                (!_vm.$v.repassword.required ||
                                  !_vm.$v.repassword.sameAsPassword)
                            },
                            model: {
                              value: _vm.repassword,
                              callback: function($$v) {
                                _vm.repassword = $$v
                              },
                              expression: "repassword"
                            }
                          }),
                          _vm._v(" "),
                          _c(
                            "a",
                            {
                              staticClass: "absolute top-0 right-0 mr-2 mt-3 ",
                              staticStyle: { cursor: "pointer" },
                              on: {
                                click: function($event) {
                                  _vm.showConfirmPassword = !_vm.showConfirmPassword
                                }
                              }
                            },
                            [
                              _c("i", {
                                staticClass: "fa",
                                class: _vm.showConfirmPassword
                                  ? "fa-eye-slash"
                                  : "fa-eye"
                              })
                            ]
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "flex flex-col pt-2" },
                        [
                          _vm.$v.repassword.$dirty &&
                          !_vm.$v.repassword.required
                            ? _c("text-error", {
                                attrs: {
                                  text: "Please fill the confirm password."
                                }
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.$v.repassword.$dirty &&
                          !_vm.$v.repassword.sameAsPassword
                            ? _c("text-error", {
                                attrs: {
                                  text:
                                    "Please fill correct the confirm password."
                                }
                              })
                            : _vm._e()
                        ],
                        1
                      )
                    ]
                  },
                  proxy: true
                }
              ])
            })
          ],
          1
        )
      ]
    ),
    _vm._v(" "),
    _c("div", { staticClass: "text-center mt-6" })
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "flex flex-col mb-2" }, [
      _c("p", { staticClass: "text-xs text-gray-700" }, [
        _vm._v("We'll crop your image to a 900×900 square.")
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-05040b97", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-05040b97","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/FormSignupUser.vue
// module id = null
// module chunks = 